/* ============================================================
   Primal Wine — Wishlist (Phase 1)
   Native, localStorage-backed. No third-party app.
   Public surface (data-attributes):
     [data-wishlist-toggle][data-wishlist-handle]  save/unsave control
     [data-wishlist-open]                           opens the drawer
     [data-wishlist-count]                          count badge (text)
     [data-wl-any]                                  header handle (fills star if any saved)
     [data-wishlist-page-container]                 full /pages/wishlist mount
   ============================================================ */
(function () {
  "use strict";
  var KEY = "pw_wishlist";
  var STAR = '<svg viewBox="0 0 24 24" class="pw-star" aria-hidden="true"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>';
  var XSVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ARROWSVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h13M12.5 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SHARESVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.5 13.5l7-4M8.5 10.5l7 4" stroke="currentColor" stroke-width="1.7"/><circle cx="6" cy="12" r="2.4" stroke="currentColor" stroke-width="1.7"/><circle cx="18" cy="7" r="2.4" stroke="currentColor" stroke-width="1.7"/><circle cx="18" cy="17" r="2.4" stroke="currentColor" stroke-width="1.7"/></svg>';

  /* ---------- storage ---------- */
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a.filter(Boolean) : []; }
    catch (e) { return []; }
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  var list = read();
  function has(h) { return list.indexOf(h) > -1; }

  /* ---------- Klaviyo (Phase 2) ---------- */
  var KL_COMPANY = "Y9Wa3b";
  var KL_LIST = "XmEwJL";            // Primary List, single opt-in
  var EMAIL_KEY = "pw_wl_email";
  function knownEmail() { try { return localStorage.getItem(EMAIL_KEY) || ""; } catch (e) { return ""; } }
  function saveEmail(em) { try { localStorage.setItem(EMAIL_KEY, em); } catch (e) {} }
  function validEmail(em) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em || ""); }
  function klPush(args) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === "function") { window.klaviyo.push(args); return true; }
      if (window._learnq && window._learnq.push) { window._learnq.push(args); return true; }
    } catch (e) {}
    return false;
  }
  function klIdentify(email) { if (email) klPush(["identify", { "$email": email }]); }
  function klTrack(name, props) { klPush(["track", name, props || {}]); }
  function trackSaved(handle) {
    getProduct(handle).then(function (p) {
      if (!p) return;
      var props = {
        ProductName: p.title, ProductID: p.id, Handle: handle,
        URL: window.location.origin + "/products/" + handle,
        Price: (p.price || 0) / 100, ImageURL: thumb(p), Brand: p.vendor,
        SoldOut: !p.available, "$value": (p.price || 0) / 100
      };
      whenIdentified(function (ok) {
        if (ok) klTrack("Saved Wishlist Item", props);
        else queueEvent("Saved Wishlist Item", props);
      });
    });
  }
  /* Marketing subscription (client API, public key). The panel states the consent
     in visible copy above the field, so custom_source below is the honest record
     of where it was given. Primary List is single opt-in, so it takes effect at once. */
  function subscribeMarketing(email) {
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KL_COMPANY, {
      method: "POST",
      headers: { "Content-Type": "application/json", accept: "application/json", revision: "2025-10-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Wishlist save",
            profile: { data: { type: "profile", attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
            } } }
          },
          relationships: { list: { data: { type: "list", id: KL_LIST } } }
        }
      })
    });
  }

  // Klaviyo native Back-in-Stock subscription (client API, public key)
  function subscribeBIS(variantId, email) {
    return fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + KL_COMPANY, {
      method: "POST",
      headers: { "Content-Type": "application/json", accept: "application/json", revision: "2025-10-15" },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: { channels: ["EMAIL"], profile: { data: { type: "profile", attributes: { email: email } } } },
          relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + variantId } } }
        }
      })
    });
  }
  function doBIS(btn, variantId, email, actEl) {
    if (btn) { btn.disabled = true; }
    saveEmail(email); klIdentify(email);
    try { subscribeMarketing(email); markSubscribed(); } catch (e) {}
    return subscribeBIS(variantId, email).then(function (r) {
      var target = actEl || (btn && btn.closest(".pw-wl-row__act"));
      if (target) target.innerHTML = '<span class="pw-wl-notified">✓ We’ll email you</span>';
      klTrack("Requested Back in Stock", { VariantID: variantId, URL: window.location.href });
      toast("We’ll email you when it’s back", "", null);
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = "Notify me"; }
      toast("Couldn’t set the alert. Try again.", "", null);
    });
  }
  function handleNotify(btn) {
    var variantId = btn.getAttribute("data-wl-notify");
    var em = knownEmail();
    if (validEmail(em)) { doBIS(btn, variantId, em); return; }
    var act = btn.closest(".pw-wl-row__act");
    if (!act) return;
    act.innerHTML = '<form class="pw-wl-notify-form" data-wl-notify-form="' + variantId + '">' +
      '<input type="email" class="pw-wl-notify-input" placeholder="your@email.com" required>' +
      '<button type="submit" class="pw-wl-row__add">Notify</button>' +
      '<span class="pw-wl-consent-note">' + CONSENT_NOTE + '</span></form>';
    var inp = act.querySelector("input"); if (inp) inp.focus();
  }

  /* ---------- identity, queued events, and the save prompt ----------
     klaviyo.push(["track", ...]) is SILENTLY DROPPED for a visitor Klaviyo has not
     identified: verified on the live PDP, an anonymous track makes zero network
     requests. Every save by a first-time shopper therefore vanished — no event, no
     count, and no address for the reminder or price-drop flows to reach.

     So: keep saving locally exactly as before, queue the event, ask for an email,
     and flush the queue the moment there is an identity to attach it to. The email
     identifies the profile; it does NOT subscribe anyone to marketing. */
  var PENDING_KEY = "pw_wl_pending";
  var SNOOZE_KEY = "pw_wl_ask_snooze";
  var SNOOZE_MS = 864e5;               // 24h, and only after an explicit dismissal

  function readPending() {
    try { var a = JSON.parse(localStorage.getItem(PENDING_KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function writePending(a) {
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(a.slice(-40))); } catch (e) {}
  }
  function queueEvent(name, props) { var q = readPending(); q.push({ n: name, p: props }); writePending(q); }
  function flushQueue() {
    var q = readPending();
    if (!q.length) return;
    writePending([]);                  // clear first: a resend beats a duplicate loop
    q.forEach(function (e) { klTrack(e.n, e.p); });
  }

  /* isIdentified() resolves a PROMISE. Testing it synchronously is always truthy
     and would silently disable this entire path. */
  function whenIdentified(cb) {
    try {
      var r = window.klaviyo && typeof window.klaviyo.isIdentified === "function" && window.klaviyo.isIdentified();
      if (r && typeof r.then === "function") { r.then(function (v) { cb(!!v); }, function () { cb(false); }); return; }
      cb(!!r);
    } catch (e) { cb(false); }
  }
  function afterIdentified(cb, tries) {
    tries = (tries == null) ? 12 : tries;      // identify() settles asynchronously
    whenIdentified(function (ok) {
      if (ok || tries <= 0) { cb(ok); return; }
      setTimeout(function () { afterIdentified(cb, tries - 1); }, 400);
    });
  }
  function snoozed() {
    try { return Date.now() < (parseInt(localStorage.getItem(SNOOZE_KEY), 10) || 0); }
    catch (e) { return false; }
  }
  function snooze() { try { localStorage.setItem(SNOOZE_KEY, String(Date.now() + SNOOZE_MS)); } catch (e) {} }

  var askHost;
  function closeAsk(remember) {
    if (remember) snooze();
    if (!askHost) return;
    var h = askHost; askHost = null;
    h.classList.remove("is-in");
    setTimeout(function () { if (h.parentNode) h.parentNode.removeChild(h); }, 380);
  }
  /* 2026-10-13 redesign (Guido: by function). Two parts: the confirmation (which wine was saved, with its photo) and,
     below it on a lavender tint, the optional ask (email for price-drop and restock alerts). Copy unchanged. */
  function showAsk(handle) {
    if (askHost) return;
    var el = document.createElement("div");
    el.className = "pw-wl-ask";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-label", "Saved to your wishlist");
    el.innerHTML =
      '<div class="pw-wl-ask__saved">' +
        '<span class="pw-wl-ask__thumb" data-wl-ask-thumb></span>' +
        '<div class="pw-wl-ask__said"><div class="pw-wl-ask__head">' + STAR + '<span>Saved to your wishlist</span></div>' +
        '<p class="pw-wl-ask__wine" data-wl-ask-wine></p></div>' +
        '<button type="button" class="pw-wl-ask__x" data-wl-ask-close aria-label="Close">' + XSVG + '</button>' +
      '</div>' +
      '<div class="pw-wl-ask__alert">' +
        '<p class="pw-wl-ask__copy">Add your email and we will tell you if it drops in price or comes back in stock.</p>' +
        '<form class="pw-wl-ask__form" data-wl-ask-form novalidate>' +
          '<input type="email" class="pw-wl-ask__input" placeholder="your@email.com" autocomplete="email" aria-label="Email address">' +
          '<button type="submit" class="pw-wl-ask__go" aria-label="Save my wishlist">' + ARROWSVG + '</button>' +
        '</form>' +
        '<p class="pw-wl-ask__consent">You will also join our list for new arrivals and offers. Unsubscribe anytime.</p>' +
        '<div class="pw-wl-ask__links"><button type="button" class="pw-wl-ask__later" data-wl-ask-close>Not now</button>' +
        '<p class="pw-wl-ask__foot">Already have an account? <a href="/account/login">Sign in</a></p></div>' +
      '</div>';
    document.body.appendChild(el);
    if (handle) getProduct(handle).then(function (p) {
      if (!p || !el.parentNode) return;
      var w = el.querySelector("[data-wl-ask-wine]"); if (w) w.textContent = p.title || "";
      var t = el.querySelector("[data-wl-ask-thumb]"), src = thumb(p);
      if (t && src) t.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
    });
    askHost = el;
    requestAnimationFrame(function () { el.classList.add("is-in"); });
    var inp = el.querySelector("input");
    if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }
  }
  /* cb(true) when the panel is showing, so the caller can skip its own toast. */
  function maybeAsk(cb, handle) {
    cb = cb || function () {};
    if (askHost) { cb(true); return; }
    var em = knownEmail();
    if (validEmail(em)) {                 // known from a notify-me signup: no need to ask
      klIdentify(em);
      afterIdentified(function () { flushQueue(); });
      cb(false); return;
    }
    whenIdentified(function (ok) {
      if (ok) { flushQueue(); cb(false); return; }
      if (snoozed()) { cb(false); return; }
      showAsk(handle); cb(true);
    });
  }
  function askSubmit(form) {
    var inp = form.querySelector("input");
    var em = ((inp && inp.value) || "").trim();
    var bad = !validEmail(em) ||
      (typeof window.PWEmailBlocklist === "function" && window.PWEmailBlocklist(em));
    if (bad) { if (inp) { inp.classList.add("is-bad"); inp.focus(); } return; }
    var go = form.querySelector('button[type="submit"]');
    if (go) go.disabled = true;
    saveEmail(em);
    klIdentify(em);
    /* Fire and forget: a subscribe failure must never cost the shopper the save
       or the wishlist emails, which only need the identify above. */
    try { subscribeMarketing(em); markSubscribed(); } catch (e) {}
    afterIdentified(function () {
      flushQueue();
      if (!askHost) return;
      askHost.innerHTML = '<div class="pw-wl-ask__ok">' + STAR +
        '<span>You are set. We will email you about this wine.</span></div>';
      setTimeout(function () { closeAsk(false); }, 2600);
    });
  }

  /* ---------- win-back prompt for shoppers we can no longer email ----------
     793 people once handed over an address to be told about a restock and are not
     subscribed: 470 unsubscribed, 323 never asked. Emailing them to win them back
     is not an option — an opt-out has to stick, and Klaviyo blocks the send anyway —
     so the ask has to happen where they ARE: on the site, on their own return.

     Targeting caveat, stated plainly: the browser cannot read consent. Klaviyo's
     getGroupMembership() never resolves (measured), and the client key is public so
     the profile API is out. So this fires on the best proxy available — a visitor
     Klaviyo recognises, who has not subscribed through our own UI — and is kept
     rare: only on pages with no notify-me form of their own (that form now does this
     job), once, after 12s, and not again for 30 days once dismissed. Some already
     subscribed people will see it; a redundant prompt is the acceptable cost, and
     submitting simply re-affirms them. */
  var SUBBED_KEY = "pw_wl_subscribed";
  var RESUB_KEY = "pw_wl_resub_snooze";
  var RESUB_MS = 2592e6;              // 30 days

  function markSubscribed() { try { localStorage.setItem(SUBBED_KEY, "1"); } catch (e) {} }
  function subscribedLocally() {
    try { return localStorage.getItem(SUBBED_KEY) === "1" || validEmail(knownEmail()); }
    catch (e) { return false; }
  }
  function resubSnoozed() {
    try { return Date.now() < (parseInt(localStorage.getItem(RESUB_KEY), 10) || 0); }
    catch (e) { return false; }
  }
  function resubSnooze() { try { localStorage.setItem(RESUB_KEY, String(Date.now() + RESUB_MS)); } catch (e) {} }

  function showResub() {
    if (askHost) return;
    var el = document.createElement("div");
    el.className = "pw-wl-ask pw-wl-ask--resub";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-label", "Hear about wines like this");
    el.innerHTML =
      '<button type="button" class="pw-wl-ask__x" data-wl-resub-close aria-label="Close">' + XSVG + '</button>' +
      '<div class="pw-wl-ask__head">' + STAR + '<span>Wines like this, when they land</span></div>' +
      '<p class="pw-wl-ask__copy">We will email you when we get wines like the ones you have been looking at, and when a sold-out favorite comes back.</p>' +
      '<p class="pw-wl-ask__consent">Joining our list for new arrivals and similar wines. Unsubscribe anytime.</p>' +
      '<form class="pw-wl-ask__form" data-wl-resub-form novalidate>' +
        '<input type="email" class="pw-wl-ask__input" placeholder="your@email.com" autocomplete="email" aria-label="Email address" value="' + (knownEmail() || "") + '">' +
        '<button type="submit" class="pw-wl-ask__go" aria-label="Sign me up">' + ARROWSVG + '</button>' +
      '</form>' +
      '<button type="button" class="pw-wl-ask__later" data-wl-resub-close>Not now</button>';
    document.body.appendChild(el);
    askHost = el;
    requestAnimationFrame(function () { el.classList.add("is-in"); });
  }
  function resubSubmit(form) {
    var inp = form.querySelector("input");
    var em = ((inp && inp.value) || "").trim();
    var bad = !validEmail(em) ||
      (typeof window.PWEmailBlocklist === "function" && window.PWEmailBlocklist(em));
    if (bad) { if (inp) { inp.classList.add("is-bad"); inp.focus(); } return; }
    var go = form.querySelector('button[type="submit"]');
    if (go) go.disabled = true;
    saveEmail(em); klIdentify(em);
    try { subscribeMarketing(em); markSubscribed(); } catch (e) {}
    if (askHost) {
      askHost.innerHTML = '<div class="pw-wl-ask__ok">' + STAR +
        '<span>You are on the list. We will be in touch when something good lands.</span></div>';
      setTimeout(function () { closeAsk(false); }, 2800);
    }
  }
  function maybeResub() {
    if (document.querySelector("form.back-in-stock-form")) return;   // that form already asks
    if (subscribedLocally() || resubSnoozed()) return;
    whenIdentified(function (ok) {
      if (!ok) return;                                              // strangers get the wishlist ask instead
      setTimeout(function () { if (!askHost) showResub(); }, 12000);
    });
  }

  /* ---------- consent note on the theme's back-in-stock form ----------
     The product page ships its own {% form 'contact' %} markup, which we upgrade in
     place rather than replace. The subscribe has to be disclosed BEFORE the shopper
     submits, so the note is injected into that form, and re-injected whenever
     component-product-form.js re-renders the block on a variant change. */
  var CONSENT_NOTE = "We will also add you to our list for new arrivals and similar wines. Unsubscribe anytime.";

  function addConsentNote(form) {
    if (!form || form.querySelector(".pw-wl-consent-note")) return;
    var note = document.createElement("p");
    note.className = "pw-wl-consent-note";
    note.textContent = CONSENT_NOTE;
    /* Append to the form, not the button's parent: that parent is the flex row
       holding the input and the button, so the note landed as a third column. */
    form.appendChild(note);
  }
  function watchBisForms() {
    document.querySelectorAll("form.back-in-stock-form").forEach(addConsentNote);
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && n.matches("form.back-in-stock-form")) addConsentNote(n);
          if (n.querySelectorAll) n.querySelectorAll("form.back-in-stock-form").forEach(addConsentNote);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- product data cache ---------- */
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }
  function money(cents) {
    if (typeof cents !== "number") return "";
    return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  }
  function firstVariant(p) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0] || null;
  }
  function thumb(p) {
    var u = p && (p.featured_image || (p.images && p.images[0]));
    if (!u) return "";
    if (u.indexOf("//") === 0) u = "https:" + u;
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=160";
  }

  /* ---------- reflect state onto all controls ---------- */
  function syncControls() {
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (b) {
      b.setAttribute("aria-pressed", has(b.getAttribute("data-wishlist-handle")) ? "true" : "false");
    });
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      /* No items means no number: an invisible "0" is dead content that
         still gets picked up by page-level scanners. */
      el.textContent = list.length > 0 ? list.length : "";
      el.classList.toggle("cart-count-badge--empty", list.length === 0);
    });
    document.querySelectorAll("[data-wl-any]").forEach(function (el) {
      el.setAttribute("data-wl-any", list.length > 0 ? "true" : "false");
    });
  }

  function toggle(handle, btn) {
    var adding = !has(handle);
    if (adding) list.push(handle);
    else list = list.filter(function (x) { return x !== handle; });
    write(list);
    syncControls();
    if (btn) { btn.classList.remove("pw-wl-pop"); void btn.offsetWidth; if (adding) btn.classList.add("pw-wl-pop"); }
    if (adding) {
      trackSaved(handle);
      maybeAsk(function (asking) {
        if (asking) return;            // the panel already says "Saved to your wishlist"
        toast("Saved to wishlist", "Undo", function () {
          list = list.filter(function (x) { return x !== handle; });
          write(list); syncControls(); renderAll();
        });
      }, handle);
    }
    renderAll();
  }

  /* ---------- add to cart ---------- */
  function addToCart(id, qty, label) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      return r.json();
    }).then(function () { return refreshCartCount(); });
  }
  function refreshCartCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll("[data-header-cart-count]").forEach(function (el) {
          el.textContent = c.item_count;
          el.classList.toggle("cart-count-badge--empty", c.item_count === 0);
        });
        return c;
      }).catch(function () {});
  }

  /* ---------- render rows into a container ---------- */
  function renderInto(container, handles, opts) {
    opts = opts || {};
    if (!container) return;
    if (!handles.length) {
      container.innerHTML =
        '<div class="pw-wl-empty"><span class="pw-wl-empty__icon">' + STAR + '</span>' +
        '<p class="pw-wl-empty__t">Nothing saved yet</p>' +
        '<p>Tap the heart on any wine to keep it here.</p>' +
        '<a class="pw-wl-empty__go" href="/collections/all">Browse wines</a></div>';
      return;
    }
    container.innerHTML = '<div class="pw-wl-empty" style="padding:34px 30px">' + STAR + '<p>Loading your wines…</p></div>';
    Promise.all(handles.slice().reverse().map(getProduct)).then(function (prods) {
      var rows = prods.map(function (p, i) {
        if (!p) return "";
        var handle = p.handle, v = firstVariant(p), img = thumb(p);
        var priceHtml = p.available ? money(v ? v.price : p.price) : '<span class="pill pill--soldout"><span class="pill__text">Sold out</span></span>';
        var soldVar = v ? v.id : (p.variants && p.variants[0] ? p.variants[0].id : "");
        var action = p.available && v
          ? '<button type="button" class="pw-wl-row__add" data-wl-add="' + v.id + '">Add to cart</button>'
          : '<button type="button" class="pw-wl-row__add is-soldout" data-wl-notify="' + soldVar + '">Notify me</button>';
        var img_el = img ? '<img src="' + img + '" alt="' + String(p.title || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;") + '" loading="lazy">' : "";
        return '<div class="pw-wl-row" data-wl-handle="' + handle + '">' +
          '<a class="pw-wl-row__img" href="/products/' + handle + '">' + img_el + '</a>' +
          '<div class="pw-wl-row__meta">' +
            '<a class="pw-wl-row__name" href="/products/' + handle + '">' + p.title + '</a>' +
            '<span class="pw-wl-row__price">' + priceHtml + '</span>' +
          '</div>' +
          '<div class="pw-wl-row__act">' + action +
            (opts.shared ? "" : '<button type="button" class="pw-wl-row__rm" data-wl-rm="' + handle + '">Remove</button>') +
          '</div></div>';
      }).join("");
      container.innerHTML = rows || '<div class="pw-wl-empty">' + STAR + '<p>These wines are no longer available.</p></div>';
    });
  }

  function currentHandles() { return list.slice(); }

  /* ---------- drawer ---------- */
  var drawer, drawerList, drawerCount, addAllBtn, lastFocus;
  function buildDrawer() {
    drawer = document.querySelector("[data-wishlist-root]");
    if (!drawer) return;
    drawerList = drawer.querySelector("[data-wishlist-container]");
    drawerCount = drawer.querySelector("[data-wishlist-drawer-count]");
    addAllBtn = drawer.querySelector("[data-wishlist-addall]");
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-wishlist-close]")) closeDrawer();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer(); });
    if (addAllBtn) addAllBtn.addEventListener("click", addAll);
    var shareBtn = drawer.querySelector("[data-wishlist-share]");
    if (shareBtn) shareBtn.addEventListener("click", share);
  }
  function renderDrawer() {
    if (!drawer) return;
    if (drawerCount) drawerCount.textContent = list.length ? list.length + (list.length === 1 ? " wine" : " wines") : "";
    if (addAllBtn) addAllBtn.disabled = list.length === 0;
    var foot = drawer.querySelector(".pw-wl__foot"); if (foot) foot.hidden = list.length === 0;   /* empty list: no Add all / Share */
    renderInto(drawerList, currentHandles(), {});
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    renderDrawer();
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    var x = drawer.querySelector(".pw-wl__x"); if (x) x.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- page ( /pages/wishlist ) ---------- */
  var pageContainer, sharedHandles = null;
  function initPage() {
    pageContainer = document.querySelector("[data-wishlist-page-container]");
    if (!pageContainer) return;
    var params = new URLSearchParams(window.location.search);
    var w = params.get("w");
    var note = document.querySelector("[data-wishlist-page-note]");
    var foot = document.querySelector("[data-wishlist-page-foot]");
    if (w) {
      sharedHandles = w.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
      if (note) {
        note.style.display = "block";
        note.innerHTML = 'Someone shared these wines with you. ' +
          '<button type="button" class="pw-wl-row__rm" data-wishlist-saveall style="font-size:12.5px">Save all to my wishlist</button>';
      }
    }
    if (foot) {
      var pShare = foot.querySelector("[data-wishlist-share]");
      var pAddall = foot.querySelector("[data-wishlist-addall]");
      if (pShare) pShare.addEventListener("click", share);
      if (pAddall) pAddall.addEventListener("click", addAll);
    }
    renderPage();
  }
  function renderPage() {
    if (!pageContainer) return;
    var handles = sharedHandles || currentHandles();
    var foot = document.querySelector("[data-wishlist-page-foot]");
    if (foot) foot.style.display = handles.length ? "flex" : "none";
    renderInto(pageContainer, handles, { shared: !!sharedHandles });
  }

  /* ---------- shared actions ---------- */
  function addAll() {
    var handles = sharedHandles || currentHandles();
    if (!handles.length) return;
    Promise.all(handles.map(getProduct)).then(function (prods) {
      var items = prods.filter(function (p) { return p && p.available; })
        .map(function (p) { var v = firstVariant(p); return v ? { id: v.id, quantity: 1 } : null; })
        .filter(Boolean);
      if (!items.length) { toast("Those wines are sold out right now", "", null); return; }
      fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { refreshCartCount(); toast("Added " + items.length + (items.length === 1 ? " wine" : " wines") + " to cart", "View cart", goCart); })
        .catch(function () { toast("Could not add to cart", "", null); });
    });
  }
  function goCart() { window.location.href = "/cart"; }
  function share() {
    var handles = currentHandles();
    if (!handles.length) { toast("Save a wine first, then share", "", null); return; }
    var url = window.location.origin + "/pages/wishlist?w=" + handles.join(",");
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { toast("Share link copied", "", null); })
        .catch(function () { prompt("Copy your wishlist link:", url); });
    } else { prompt("Copy your wishlist link:", url); }
  }

  /* ---------- toast ---------- */
  var toastHost;
  function toast(msg, actionLabel, onAction) {
    if (!toastHost) { toastHost = document.querySelector("[data-wl-toasts]"); }
    if (!toastHost) return;
    var t = document.createElement("div");
    t.className = "pw-wl-toast";
    t.innerHTML = (/^Saved/.test(msg) ? STAR : "") + "<span><b>" + msg + "</b></span>" + (actionLabel ? '<button type="button">' + actionLabel + "</button>" : "");
    toastHost.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-in"); });
    var done = false;
    function kill() { if (done) return; done = true; t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 400); }
    if (actionLabel && onAction) t.querySelector("button").addEventListener("click", function () { onAction(); kill(); });
    setTimeout(kill, actionLabel ? 4600 : 2800);
  }

  function renderAll() { renderDrawer(); renderPage(); }

  /* ---------- global delegation ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-wishlist-toggle]");
    if (t) { e.preventDefault(); toggle(t.getAttribute("data-wishlist-handle"), t); return; }
    var open = e.target.closest("[data-wishlist-open]");
    if (open) { e.preventDefault(); openDrawer(); return; }
    var add = e.target.closest("[data-wl-add]");
    if (add) {
      e.preventDefault(); add.disabled = true; add.textContent = "Adding…";
      addToCart(parseInt(add.getAttribute("data-wl-add"), 10), 1).then(function () {
        add.textContent = "Added"; toast("Added to cart", "View cart", goCart);
        setTimeout(function () { add.disabled = false; add.textContent = "Add to cart"; }, 1400);
      }).catch(function () { add.disabled = false; add.textContent = "Add to cart"; toast("Could not add to cart", "", null); });
      return;
    }
    var notify = e.target.closest("[data-wl-notify]");
    if (notify) { e.preventDefault(); handleNotify(notify); return; }
    var rm = e.target.closest("[data-wl-rm]");
    if (rm) {
      e.preventDefault();
      var h = rm.getAttribute("data-wl-rm");
      list = list.filter(function (x) { return x !== h; });
      write(list); syncControls(); renderAll();
      return;
    }
    var askClose = e.target.closest("[data-wl-ask-close]");
    if (askClose) { e.preventDefault(); closeAsk(true); return; }
    var resubClose = e.target.closest("[data-wl-resub-close]");
    if (resubClose) { e.preventDefault(); resubSnooze(); closeAsk(false); return; }
    var saveAll = e.target.closest("[data-wishlist-saveall]");
    if (saveAll && sharedHandles) {
      e.preventDefault();
      sharedHandles.forEach(function (h) { if (!has(h)) list.push(h); });
      write(list); syncControls();
      toast("Saved to your wishlist", "", null);
      return;
    }
  });

  /* ---------- inline "notify me when back in stock" email form ---------- */
  document.addEventListener("submit", function (e) {
    var af = e.target.closest("[data-wl-ask-form]");
    if (af) { e.preventDefault(); askSubmit(af); return; }
    var rf = e.target.closest("[data-wl-resub-form]");
    if (rf) { e.preventDefault(); resubSubmit(rf); return; }
    var f = e.target.closest("[data-wl-notify-form]");
    if (!f) return;
    e.preventDefault();
    var variantId = f.getAttribute("data-wl-notify-form");
    var inp = f.querySelector("input");
    var em = (inp && inp.value || "").trim();
    if (!validEmail(em)) { toast("Enter a valid email", "", null); if (inp) inp.focus(); return; }
    doBIS(f.querySelector("button"), variantId, em, f.closest(".pw-wl-row__act"));
  });

  /* ---------- PDP / featured-product "Notify me" → Klaviyo back-in-stock ----------
     The theme ships this block as a plain Shopify {% form 'contact' %}, which only
     emails the shop inbox: no Klaviyo subscription, so those customers never enter
     the live Back In Stock flow. We upgrade it in place.

     Progressive enhancement on purpose. The markup is untouched, so if this script
     fails to load, or the Klaviyo call errors, the form still posts to /contact and
     behaves exactly as it did before. Nothing regresses, it just stops being smart.

     Delegated on document because component-product-form.js re-renders the whole
     [data-update-block="back-in-stock"] subtree on every variant change. The variant
     id is read from the block's own data-url, which is re-rendered with it, so multi
     variant products subscribe to the variant actually selected. */
  function bisSuccess(form, msg) {
    var wrap = document.createElement("p");
    wrap.className = "alert alert--success pw-wl-bis-ok";
    wrap.style.marginTop = "1rem";
    wrap.textContent = msg;
    var fs = form.querySelector("fieldset") || form;
    fs.parentNode.replaceChild(wrap, fs);
  }
  /* CAPTURE phase, deliberately. Shopify's bot-protection script binds submit on
     document in the BUBBLE phase for every form[action*='/contact'], calls
     preventDefault, then re-submits the form itself. Listening in capture lets us
     take the event over first; stopImmediatePropagation then keeps that script (and
     the double submit it would cause) out of the way. Bubble-phase listening cannot
     work here: by the time it runs, defaultPrevented is already true. */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest && e.target.closest("form.back-in-stock-form");
    if (!form) return;
    // Set when our own fallback re-submits: let the stock Shopify path run.
    if (form.__pwBisFallback) return;

    var block = form.closest("back-in-stock-form");
    var url = block && block.getAttribute("data-url");
    var m = url && url.match(/variant=(\d+)/);
    var variantId = m && m[1];
    var inp = form.querySelector('input[name="contact[email]"], input[type="email"]');
    var em = ((inp && inp.value) || "").trim();

    // Nothing to subscribe, or an address we can't parse: leave it to Shopify.
    if (!variantId || !validEmail(em)) return;
    // Known bot domain: bail without preventing, so email-validator.js shows its
    // error on the form as usual. One blocklist, one owner.
    if (typeof window.PWEmailBlocklist === "function" && window.PWEmailBlocklist(em)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[type="submit"]');
    var label = btn && btn.querySelector(".button__text");
    var original = label ? label.textContent : "";
    if (btn) { btn.disabled = true; }
    if (label) { label.textContent = "Adding you…"; }

    saveEmail(em); klIdentify(em);
    try { subscribeMarketing(em); markSubscribed(); } catch (e) {}
    subscribeBIS(variantId, em).then(function (r) {
      if (!r || !r.ok) throw new Error("BIS " + (r && r.status));
      klTrack("Requested Back in Stock", {
        VariantID: variantId, URL: window.location.href, Source: "Product page"
      });
      bisSuccess(form, "Thanks. We’ll email you the moment this is back.");
    }).catch(function () {
      // Hand back to the original Shopify contact form, captcha script included,
      // so a Klaviyo outage can never swallow a signup.
      if (label) { label.textContent = original; }
      if (btn) { btn.disabled = false; }
      form.__pwBisFallback = true;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }, true);

  /* ---------- boot ---------- */
  function boot() {
    buildDrawer();
    syncControls();
    initPage();
    watchBisForms();
    maybeResub();
    var known = knownEmail();
    if (validEmail(known)) klIdentify(known);
    afterIdentified(function (ok) { if (ok) flushQueue(); }, 3);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && askHost) closeAsk(true);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
